// src/sot/primitives/AvatarThumb44.jsx
import React from "react";
import AvatarThumb68 from "./AvatarThumb68.jsx";

export default function AvatarThumb44(props) {
  return <AvatarThumb68 size={44} shape="circle" {...props} />;
}
